<template>
	<div v-show="showReport">
		<div class="p-grid">
			<Toast />
			<div class="p-col-12 p-md-4">
				<div class="card">
					<h1>{{$t('PlayerCard')}}</h1>
					<Carousel v-if="showCarousel" ref="mycarousel" @update:page="handlePlayerSelected" :value="playersList" :numVisible="1" :numScroll="1" :page="playerIndex" :circular="true">
						<template #item="slotProps">
							<PlayerCard :player-data="slotProps.data" :is-transfer-player="true" :key="rerenderCard" />
						</template>
					</Carousel>
					<PlayerCard v-else :player-data="playerData" :is-transfer-player="isTransferPlayer" />
				</div>
			</div>
			<div class="p-col-12 p-md-8">
				<RequestPlayerMatch v-if="requestId" :request-id="requestId" :player-id="playerId" />
				<PlayerSkillsList v-model="playerData.Skills" :skills-evaluations="skillsEvaluantions" :skills-evaluations-names="skillsEvaluationNames" :key="rerenderSkills" />
			</div>
			<div class="p-col-12 p-md-4">
				<VideoPreview :videoUrl="(playerData.Videos != null && playerData.Videos.length > 0) ? playerData.Videos[0].VideoUrl : null" />
			</div>
			<div class="p-col-12 p-md-8">
				<PlayerCareerChart :player-data="playerData" :key="rerenderChart" :is-transfer-player="isTransferPlayer" />
			</div>
		</div>
	</div>
</template>

<script>
import RequestPlayerMatch from "@/components/request/RequestPlayerMatch";
import PlayerCareerChart from "@/components/player/PlayerCareerChart";
import PlayerSkillsList from "@/components/skills/PlayerSkillsList";
import PlayerCard from "@/components/player/PlayerCard";
import VideoPreview from "@/components/VideoPreview";
import CommonService from "@/service/CommonService";
import EnumService from "@/service/EnumService";
import PlayerService from "@/service/PlayerService";
import AuthService from "@/service/AuthService";
import AgentService from "@/service/AgentService";

export default {
	components: {
		RequestPlayerMatch,
		PlayerCareerChart,
		PlayerSkillsList,
		PlayerCard,
		VideoPreview,
	},
	props: [
		"playersList",
		"playerIndex",
		"playerId",
		"isTransferPlayer",
		"requestId",
	],
	data: function () {
		return {
			rerenderCard: 0,
			rerenderChart: 0,
			rerenderSkills: 0,
			showReport: false,
			playerData: {},
			fromDialog: false,
			showCarousel: false,
			tiers: false,
			skillsEvaluantions: [],
			skillsEvaluationNames: [],
		};
	},
	commonService: null,
	playerService: null,
	authService: null,
	agentService: null,
	enumService: null,
	created() {
		this.commonService = new CommonService();
		this.playerService = new PlayerService();
		this.authService = new AuthService();
		this.agentService = new AgentService();
		this.enumService = new EnumService();

		if (this.playerId == null) {
			this.playerId = this.$route.params.playerId;
			if (this.playerId == null)
				this.playerId = this.$route.query.playerId;
			if (this.playerId != null)
				this.playerService
					.isTransferPlayer(this.playerId)
					.then((res) => {
						this.isTransferPlayer = res.data;
					});
		}

		if (this.playerId) {
			let self = this;
			this.playerService.getPlayerProfile(this.playerId).then(
				(res) => {
					self.playerData = res.data;

					self.getPlayerSkillsEvaluations(self.playerId);
					self.addProfileViewed(self.playerId);

					// transform skills
					let skills = [];
					self.playerData.Skills.forEach(function (i) {
						skills.push(i.Skill);
					});
					self.playerData.Skills = skills;

					self.isTransferPlayer = self.playerData.FromTransfer;

					// refresh page
					self.showReport = true;
					self.rerenderChart += 1;
					self.rerenderSkills += 1;
				},
				function (err) {
					self.$toast.add({
						severity: "error",
						summary: self.$t("errorMessage"),
						detail: self.$t("Error"),
						life: 3000,
					});
				}
			);
		} else {
			// player from dialog
			if (Array.isArray(this.playersList)) {
				this.playerData = this.playersList[this.playerIndex];
				this.showCarousel = true;
			} else this.playerData = this.playersList;
			this.fromDialog = true;
		}
	},
	mounted() {
		if (this.fromDialog) {
			this.showReport = true;
			this.rerenderCard += 1;
		}
	},
	methods: {
		handlePlayerSelected(index) {
			this.playerData = this.playersList[index];
			this.rerenderChart += 1;
			this.rerenderSkills += 1;
		},
		languageChanged() {
			this.rerenderChart += 1;
			this.rerenderSkills += 1;
		},
		getPlayerSkillsEvaluations(playerId) {
			let self = this;

			this.playerService
				.getPlayerSkillsEvaluations(playerId)
				.then((res) => {
					res.data.forEach(function (v) {
						// add skill counts
						if (v.SkillEvaluated != null) {
							self.skillsEvaluantions[v.SkillEvaluated] =
								(self.skillsEvaluantions[v.SkillEvaluated] ||
									0) + 1;

							// add skill evaluations persons
							if (
								typeof self.skillsEvaluationNames[
									v.SkillEvaluated
								] !== "undefined"
							)
								self.skillsEvaluationNames[v.SkillEvaluated] +=
									v.EvaluatorName +
									" - " +
									self.enumService.getEnumName(
										self.enumService.getSkillsEvaluatorRoleEnum(),
										v.EvaluatorRole
									) +
									"\n";
							else
								self.skillsEvaluationNames[v.SkillEvaluated] =
									v.EvaluatorName +
									" - " +
									self.enumService.getEnumName(
										self.enumService.getSkillsEvaluatorRoleEnum(),
										v.EvaluatorRole
									) +
									"\n";
						}
						self.rerenderSkills += 1;
					});
				})
				.catch((error) => {});
		},
		addProfileViewed(playerId) {
			let self = this;

			this.playerService
				.addPlayerProfileViewed(playerId)
				.then((res) => {})
				.catch((error) => {});
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .p-carousel .p-carousel-dots-container {
	display: none;
}
</style>